<template>
  <div class="profile page">
    <div class="page-header">
      <div class="container">
        <h1 class="title">{{ $t('pagetitle.profile') }}</h1>
      </div>
    </div>
    <div class="page-body">
      <div class="container">
        <div class="customer">
          <h1 class="title">{{ $t('title.customerdetails') }}</h1>
          <span>{{ $t('profile.customername') }}: {{ this.$store.getters.name }}</span>
          <span>{{ $t('profile.email') }}: {{ this.$store.getters.email }}</span>
          <span>{{ $t('profile.contactperson') }}: {{ this.$store.getters.person }}</span>
          <span>{{ $t('profile.contactnumber') }}: {{ this.$store.getters.phone }}</span>
          <!-- <span>{{ $t('profile.address1') }}</span>
          <span>{{ $t('profile.address2') }}</span> -->
        </div>
        <div class="address">
          <h1 class="title">{{ $t('title.outlets') }}</h1>
          <div class="address-row">
            <div class="item" v-for="(address, index) in addresses" :key="index" :class="{ 'active': primary === address.id }">
              <div class="item-padding">
                <div class="item-title">
                  <span v-if="primary === address.id">{{ $t('button.primary') }}</span>
                </div>
                <div class="item-desc">
                  <h2 style="font-weight: bold">{{ address.branch }}</h2>
                  <h2>{{ address.address1 }}</h2>
                  <h2 v-if="address.address2">{{ address.address2 }}</h2>
                  <h2>{{ address.postcode }}, {{ address.city }}</h2>
                  <h2>{{ address.state }}, {{ address.country }}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="credit" v-if="credit">
          <h1 class="title">{{ $t('title.creditterms') }}</h1>
          <span>{{ credit ? credit.name: '' }}</span>
          <!-- <span>{{ credit ? credit.description: '' }}</span> -->
        </div>
        <div class="disclaimer">
          <span>{{ $t('subtitle.disclaimer') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Site from '@/api/site'
export default {
  name: 'profile',
  components: {
  },
  data () {
    return {
      addresses: [],
      credit: undefined,
      primary: 0
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      const data = { id: this.$store.getters.id }
      Site.getUserProfile(data).then((res) => {
        // console.log(res.result)
        this.primary = res.result.primary_address_id
        this.addresses = res.result.address
        this.credit = res.result.credit
      }).catch((err) => {
        console.log(err)
      })
    }
    // onLoadAddress () {
    //   Site.getAddressByUserId(this.$store.getters.id).then((res) => {
    //     this.addresses = res.result
    //     console.log(this.addresses)
    //   }).catch((err) => {
    //     console.log(err)
    //   })
    // },
    // onLoadCredit () {
    //   Site.getCreditById().then((res) => {
    //   console.log(res)
    //   }).catch((err) => {
    //     console.log(err)
    //   })
    // }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/settings.scss";
.profile {
  .customer, .credit {
    span {
      display: block;
      padding-bottom: 5px;
    }
  }
  .disclaimer {
    padding: 15px 0;
  }
  .address-row {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: row;
    flex-wrap: wrap;
    flex-flow: row wrap;
    align-content: flex-end;
    // column-count: 1;
    @media (min-width: 768px) {
      // column-count: 3;
    }
    .item {
      display: flex;
      width: 50%;

      @media (min-width: 768px) {
        width: 25%;
      }
      &.active {
        & > .item-padding {
          border-color: $orange-light-color;
          & .item-title {
            text-transform: uppercase;
            font-size: 14px;
            font-weight: bold;
            display: flex;
            justify-content: center;
            background-color: $orange-light-color;
            height: 16px;
            padding: 4px;
          }
        }
      }

      .item-padding {
        display: flex;
        flex-direction: column;
        width: 100%;
        border: 1px solid $gray-color;
        border-radius: 3px;
        background-color: $white-color;
        cursor: pointer;
        margin: 5px;
        & .item-title {
          display: flex;
          justify-content: center;
          background-color: $gray-color;
          height: 16px;
          padding: 4px;
        }
        & > .item-desc {
          padding: 5px 10px 10px 10px;
        }
      }
      h1 {
        font-size: 18px;
      }
      h2 {
        font-size: 16px;
        font-weight: normal;
        margin: 5px 0;
      }
      img {
        width: 100%;
        max-width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/profile/index.vue